import React, { useEffect, useState } from 'react'
import { useBnsBaoZhuangUpdateQuery } from '../../store/ReactWebSiteApi';
import { Descriptions, Spin } from 'antd';
import DocTitle from '../../cpn/DocTitle';
import PackageEdit from './PackageEdit';
function PackageDesc(props) {
    const [info,setInfo] = useState({
        ebn_team_num:'',
    })
    const {data,isSuccess} = useBnsBaoZhuangUpdateQuery({bbz_id:props.bbz_id},{skip:!props.bbz_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({
                    bbz_name:data.Result.bbz_name,        
                    bbz_type_name:data.Result.bbz_type_name,        
                    bbz_dept_name:data.Result.bbz_dept_name,                                     
                    bbz_content:data.Result.bbz_content,                                     
                    bbz_bg_name:data.Result.bbz_bg_name,                                     
                    bbz_cname:data.Result.bbz_cname,                                     
                    bbz_ctime:data.Result.bbz_ctime,                                     
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])

    const items = [
        {
            key:'bbz_type_name',
            label:'平台',
            children:<>{info.bbz_type_name}</>,
            labelStyle:{width:'100px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'bbz_bg_name',
            label:'产品',
            children:<>{info.bbz_bg_name}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"},
            span:2
        },
        {
            key:'1',
            label:'标题',
            children:<>{info.bbz_name}</>,
            labelStyle:{width:'100px'},
            contentStyle:{fontSize:"18px"},
            span:3
        },
        {
            key:'2',
            label:'正文',
            children:<div dangerouslySetInnerHTML={{__html:info.bbz_content}}></div>,
            contentStyle:{fontSize:"18px"},
            span:3,
        },
        {
            key:'12',
            label:'部门',
            children:<>{info.bbz_dept_name}</>,
            labelStyle:{width:'100px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'8',
            label:'新增时间',
            children:info.bbz_cname+info.bbz_ctime,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'3',
            label:'操作',
            children:<PackageEdit bbz_id={props.bbz_id} />,
        },
    ]
    return (
        <>
            {info.bbz_type_name ? <div 
                                    style={{border:'2px solid #eee',margin:"10px",padding:'20px'}}
                                >
                                   <DocTitle
                                        name='推广方案'
                                        num={props.bbz_id}                        
                                    />                                    
                                    <Descriptions
                                        items={items}
                                        bordered
                                    />
                                </div>:  <Spin  size='large' />}
        </> 
    )
}

export default PackageDesc